// Official combined logo (emblem + AarogyaInnovate.AI name) used as the trademark
export const BRAND_LOGO = "/aarogya-innovate-logo-full.png";
export const BRAND_MARK = "/aarogya-innovate-logo.png"; // emblem only (icons / tiny spots)

const C = { aarogya: "#3DA635", innovate: "#2E73B8", dot: "#2E73B8", a: "#C0392B", i: "#1E3A6E" };

// Crisp colored wordmark with a small ™ (legible at small sizes)
export function BrandWordmark({ className = "" }) {
  return (
    <span className={`font-bold tracking-tight whitespace-nowrap ${className}`} data-testid="brand-wordmark">
      <span style={{ color: C.aarogya }}>Aarogya</span>
      <span style={{ color: C.innovate }}>Innovate</span>
      <span style={{ color: C.dot }}>.</span>
      <span style={{ color: C.a }}>A</span>
      <span style={{ color: C.i }}>I</span>
      <sup className="font-semibold text-stone-400 ml-0.5" style={{ fontSize: "0.55em" }}>™</sup>
    </span>
  );
}

// Floating brand logo shown centered at the bottom of every page
export function BrandBadge() {
  return (
    <div
      className="fixed bottom-2 left-1/2 -translate-x-1/2 z-[45] pointer-events-none flex items-center justify-center"
      data-testid="brand-badge"
    >
      <img src={BRAND_LOGO} alt="AarogyaInnovate.AI™" className="h-12 w-auto select-none" />
    </div>
  );
}
